module.exports = __webpack_public_path__ + "img/section_2-svg_2.f0520f14.svg";